import PdfAssetLine from './PdfAssetLine/PdfAssetLine';
import { ReportPDFAsset } from 'queries/report/contract';
import './style.scss';
import React from 'react';
import { CaseListItem } from 'queries/cases/types';

type AssetProps = {
  data: ReportPDFAsset;
  casesComponent?: React.FC<{ cases: CaseListItem[] }>;
  depth?: number;
  isFirstLevel?: boolean;
  casesHeader?: React.FC;
};

export const PdfAssetsList: React.FC<AssetProps> = ({
  data,
  casesComponent,
  depth = 2,
  isFirstLevel = true,
  casesHeader,
}: AssetProps) => {
  if (depth === 0) {
    return null;
  }

  if ('children' in data) {
    return data.children
      ?.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      })
      .map((child) => {
        const isLastLevel = 'cases' in child;
        const shouldBreakLine = isLastLevel && casesComponent && child?.children?.length === 0;

        return (
          <React.Fragment>
            {PdfAssetLine({
              asset: child,
              isParent: isFirstLevel,
              newLine: shouldBreakLine,
              showHealthBar: isFirstLevel || !casesComponent,
              className: `${isLastLevel && 'pdf-list-cases'} ${
                depth === 2 && casesHeader && 'pdf-list-cases-header'
              }`,
              children: () => {
                if (depth === 2 && casesHeader) {
                  return casesHeader({});
                }

                return isLastLevel && casesComponent
                  ? casesComponent({ cases: child.cases ?? [] })
                  : null;
              },
            })}

            {'children' in child &&
              PdfAssetsList({
                data: child,
                depth: depth - 1,
                isFirstLevel: false,
                casesComponent,
                casesHeader,
              })}
          </React.Fragment>
        );
      });
  }

  return null;
};
